/**
 * API клієнт для doc.price_change (Порція Роздріб.4/5a).
 * Backend: /api/v1/retail/price-changes.
 *
 * Permissions:
 *  - retail.price_change.create — POST/PATCH/DELETE/GET
 *  - retail.price_change.post — /post, /unpost
 */
import { api } from './client';
import type { Page } from './catalogs';

export interface PriceChangeItemIn {
  line_number: number;
  nomenclature_id: string;
  new_price: string;
}

export interface PriceChangeItem {
  id: string;
  line_number: number;
  nomenclature_id: string;
  old_price: string | null;
  new_price: string;
  change_percent: string | null;
}

export interface PriceChangeListItem {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  price_group_id: string;
  effective_from: string;
  change_reason: string | null;
  posted: boolean;
  deletion_mark: boolean;
}

export interface PriceChange extends PriceChangeListItem {
  posted_at: string | null;
  created_at: string;
  created_by: string | null;
  comment: string | null;
  items: PriceChangeItem[];
}

export interface PriceChangeCreate {
  organization_id: string;
  document_number?: string | null;
  document_date?: string | null;
  price_group_id: string;
  effective_from?: string | null;
  change_reason?: string | null;
  items: PriceChangeItemIn[];
  comment?: string | null;
}

export interface PriceChangeUpdate {
  document_number?: string | null;
  document_date?: string | null;
  effective_from?: string | null;
  change_reason?: string | null;
  items?: PriceChangeItemIn[];
  comment?: string | null;
}

export const retailPriceChanges = {
  list: (params?: {
    organization_id?: string;
    price_group_id?: string;
    posted?: boolean;
    limit?: number;
    offset?: number;
  }) =>
    api.get<Page<PriceChangeListItem>>('/retail/price-changes', { params }).then((r) => r.data),
  get: (id: string) => api.get<PriceChange>(`/retail/price-changes/${id}`).then((r) => r.data),
  create: (payload: PriceChangeCreate) =>
    api.post<PriceChange>('/retail/price-changes', payload).then((r) => r.data),
  update: (id: string, payload: PriceChangeUpdate) =>
    api.patch<PriceChange>(`/retail/price-changes/${id}`, payload).then((r) => r.data),
  remove: (id: string) => api.delete(`/retail/price-changes/${id}`).then(() => undefined),
  post: (id: string) => api.post<PriceChange>(`/retail/price-changes/${id}/post`).then((r) => r.data),
  unpost: (id: string) =>
    api.post<PriceChange>(`/retail/price-changes/${id}/unpost`).then((r) => r.data),
};
